import React from "react";
import { Formik, Form, Field } from "formik";
import {
  Button,
  LinearProgress,
  FormControlLabel,
  Box,
} from "@material-ui/core";

import { TextField, Switch } from "formik-material-ui";
import { makeStyles } from "@material-ui/core/styles";
import { withStyles } from "@material-ui/styles";
import { yellow } from "@material-ui/core/colors";
import Checkbox from "@material-ui/core/Checkbox";
import { useDispatch } from "react-redux";
import * as authAction from "../../store/actions/auth";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: 400,
    },
    "& .MuiBox-root": {
      marginLeft: 0,
    },
    "@media (max-width: 900px)": {
      "& .MuiTextField-root": {
        margin: theme.spacing(1),
        width: 250,
      },
      "& .MuiBox-root": {
        marginLeft: 0,
      },
    },
  },
  buttonStyle: {
    backgroundColor: "#FCD535",
    color: "#212833",
    width: 400,
    "@media (max-width: 900px)": {
      width: 250,
    },
  },
}));

const GreenCheckbox = withStyles({
  root: {
    color: yellow[400],
    "&$checked": {
      color: yellow[600],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

const LoginInput = ({ checkRemember, isRegister }) => {
  const dispatch = useDispatch();
  const { root, buttonStyle } = useStyles();
  const [state, setState] = React.useState({
    checkedG: true,
  });

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };
  const signUpUser = async (email, password) => {
    try {
      await dispatch(authAction.signup(email, password));
    } catch (error) {
      console.log(error);
    }
    // createUserWithEmailAndPassword(auth, email, password)
    //   .then((userCredential) => {
    //     // Signed in
    //     const user = userCredential.user;
    //     console.log("user", user);
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  };
  const signInUser = async (email, password) => {
    try {
      await dispatch(authAction.login(email, password));
    } catch (error) {
      console.log(error);
    }
    // signInWithEmailAndPassword(auth, email, password)
    //   .then((userCredential) => {
    //     // Signed in
    //     const user = userCredential.user;
    //     console.log("signed user", user);
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  };
  return (
    <Formik
      initialValues={{
        email: "",
        password: "",
        rememberMe: true,
      }}
      validate={(values) => {
        const errors = {};
        if (!values.email) {
          errors.email = "Required";
        } else if (
          !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
        ) {
          errors.email = "Invalid email address";
        }
        return errors;
      }}
      onSubmit={async (values, { setSubmitting, resetForm }) => {
        if (isRegister) {
          signUpUser(values.email, values.password);
          setSubmitting(false);
          resetForm();
        } else {
          signInUser(values.email, values.password);
          setSubmitting(false);
          resetForm();
        }
      }}
    >
      {({ submitForm, isSubmitting, touched, errors }) => (
        <Form className={root}>
          <Box>
            <Field
              variant="outlined"
              component={TextField}
              name="email"
              type="email"
              label="Email"
            />
          </Box>
          <Box>
            <Field
              variant="outlined"
              component={TextField}
              type="password"
              label="Password"
              name="password"
            />
          </Box>
          {checkRemember ? (
            <Box margin={1}>
              <FormControlLabel
                control={
                  <Field component={Switch} type="checkbox" name="rememberMe" />
                }
                label="Remember Me"
              />
            </Box>
          ) : null}
          {isRegister ? (
            <FormControlLabel
              control={
                <GreenCheckbox
                  checked={state.checkedG}
                  onChange={handleChange}
                  name="checkedG"
                />
              }
              label="I have read and agree to ethlink's Terms of Service"
            />
          ) : null}

          {isSubmitting && <LinearProgress />}

          <Box margin={1}>
            <Button
              className={buttonStyle}
              variant="contained"
              disabled={isSubmitting}
              onClick={submitForm}
            >
              Submit
            </Button>
          </Box>
        </Form>
      )}
    </Formik>
  );
};

export default LoginInput;
